import React from "react";
import "./styles.css";
import WaterJugProblem from "./WaterJugProblem";

const App = () => {
  return (
    <div className="App">
      <h1>Water Jug Problem Solver</h1>
      <WaterJugProblem />
    </div>
  );
};

export default App;
